import { render, staticRenderFns } from "./B2bTab.vue?vue&type=template&id=20e56f7e&scoped=true&"
import script from "./B2bTab.vue?vue&type=script&lang=js&"
export * from "./B2bTab.vue?vue&type=script&lang=js&"
import style0 from "./B2bTab.vue?vue&type=style&index=0&id=20e56f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e56f7e",
  null
  
)

export default component.exports